import * as React from "react";
import { Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { Routes } from "../../routes/routes";
import { Menu } from "../Menu/Menu";
import { Navigation } from "../Navigation/Navigation";
import { AsyncUsersPage, AsyncUserPage, AsyncPermissionsPage } from "../../routes/asyncRoutes";
import { ErrorBoundary } from "../ErrorBoundary/ErrorBoundary";
import { BigLoader } from "../BigLoader/BigLoader";
import { AdminsProfilesPage } from "../../pages/AdminsProfilesPage/AdminsProfilesPage";
import { ParentsProfilesPage } from "../../pages/ParentsProfilesPage/ParentsProfilesPage";
import { TutorsProfilesPage } from "../../pages/TutorsProfilesPage/TutorsProfilesPage";
import { SupervisorsProfilesPage } from "../../pages/SupervisorsProfilesPage/SupervisorsProfilesPage";
import { StudentsProfilesPage } from "../../pages/StudentsProfilesPage/StudentsProfilesPage";
import { AssistantsProfilesPage } from "../../pages/AssistantsProfilesPage/AssistantsProfilesPage";
import { ContentMakersProfilesPage } from "../../pages/ContentMakersProfilesPage/ContentMakersProfilesPage";

interface ContentProps {
  open: boolean;
  onDrawerClose: () => void;
}

export function Content({ open, onDrawerClose }: ContentProps) {
  return (
    <Menu>
      <Menu.Nav>
        <Navigation open={open} onDrawerClose={onDrawerClose} />
      </Menu.Nav>
      <Menu.Content>
        <ErrorBoundary>
          <Suspense fallback={<BigLoader />}>
            <Switch>
              <Redirect from="/" exact to={`/${Routes.users}`} />
              <Route path={`/${Routes.user}/:id`} component={AsyncUserPage} />
              <Route path={`/${Routes.users}`} component={AsyncUsersPage} />
              <Route path={`/${Routes.admins}`} component={AdminsProfilesPage} />
              <Route path={`/${Routes.supervisors}`} component={SupervisorsProfilesPage} />
              <Route path={`/${Routes.tutors}`} component={TutorsProfilesPage} />
              <Route path={`/${Routes.students}`} component={StudentsProfilesPage} />
              <Route path={`/${Routes.parents}`} component={ParentsProfilesPage} />
              <Route path={`/${Routes.assistants}`} component={AssistantsProfilesPage} />
              <Route path={`/${Routes.contenters}`} component={ContentMakersProfilesPage} />
              <Route path={`/${Routes.permissions}`} component={AsyncPermissionsPage} />
            </Switch>
          </Suspense>
        </ErrorBoundary>
      </Menu.Content>
    </Menu>
  );
}
